import Vue from 'vue'
import locale from 'element-ui/lib/locale'
import VueI18n from 'vue-i18n'
import messages from './langs'
let lang = localStorage.language ? localStorage.language : navigator.language.substring(0, 2)
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: lang,
  messages: messages
})
locale.i18n((key, value) => i18n.t(key, value))
export default i18n
